export enum MapTopoLayerType {
  DEFAULT = 'DEFAULT',
  TOPO = 'TOPO',
  WXTILES = 'WXTILES',
}
